export default __webpack_public_path__ + "static/media/card-sleep-icon.fd8176c7.svg";